import { queryOptions } from '@tanstack/react-query';

import { countCsvWidgetExportRows } from '@/features/data-hub/components/CsvWidgetExport/downloadCsvWidgetExport';
import type { CsvWidgetExportSource } from '@/features/data-hub/types/context.types';

export const csvWidgetExportOptions = {
  rowCount: (
    source: CsvWidgetExportSource | null,
    dateColumnKey: string | null,
    requestFrom: string | null,
    requestTo: string | null
  ) =>
    queryOptions({
      queryKey: [
        'csv-widget-export-items-count',
        source,
        dateColumnKey,
        requestFrom,
        requestTo
      ] as const,
      staleTime: 30_000,
      queryFn: async () => {
        if (!source) return 0;
        return countCsvWidgetExportRows(
          source,
          requestFrom ?? undefined,
          requestTo ?? undefined,
          dateColumnKey
        );
      }
    })
};
